import React, { useState, useEffect, useCallback } from 'react'; 
import { auth, db } from '../FirebaseComp/firebase';
import { collection, getDocs, deleteDoc, doc, updateDoc, addDoc, query, orderBy, onSnapshot, limit, where, serverTimestamp } from 'firebase/firestore';

import jsPDF from 'jspdf';
import * as XLSX from 'xlsx';
import './adminpanel.css';








function AdminPanel() {
  const [activeTab, setActiveTab] = useState('viewAllSubmission'); // Default tab
  const [users, setUsers] = useState([]);


  // Fetch all users
  const fetchUsers = useCallback(async () => {
    try {
      const userRef = collection(db, 'users');
      const snapshot = await getDocs(userRef);
      const usersData = snapshot.docs.map(doc => ({ ...doc.data(), id: doc.id }));
      setUsers(usersData);
    } catch (error) {
      console.error("Error fetching users:", error.message);
    }
  }, []);

  useEffect(() => {
    if (activeTab === 'viewUsers' || activeTab === 'manageUsers') {
      fetchUsers();
    }
  }, [activeTab, fetchUsers]);

  // Remove user with confirmation
  const handleRemoveUser = async (userId) => {
    const confirmDelete = window.confirm("Are you sure you want to delete this member?");
    if (!confirmDelete) return; 

    try {
      await deleteDoc(doc(db, 'users', userId));  
      setUsers(prevUsers => prevUsers.filter(user => user.id !== userId)); 
    } catch (error) {
      console.error("Error removing user:", error.message);
    }
  };

  const handleTabClick = (tabName) => {
    setActiveTab(tabName);
  };



  const handleLogout = async () => {
    try {
      await auth.signOut();
      window.location.href = '/';  
    } catch (error) {
      console.error("Error logging out:", error.message);
    }
  };

  useEffect(() => {
    document.body.classList.add('admin-panel-active');
    return () => {
      document.body.classList.remove('admin-panel-active');
    };
  }, []);





//fetch all the messages from the contacts
const [messages, setMessages] = useState([]);

useEffect(() => {
  const fetchMessages = async () => {
    try {
      const querySnapshot = await getDocs(collection(db, "contacts"));
      const contactMessages = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setMessages(contactMessages);
    } catch (error) {
      console.error("Error fetching messages:", error);
    }
  };

  fetchMessages();
}, []);




//fetch all submission
// const [submissions, setSubmissions] = useState([]);

// useEffect(() => {
//   const fetchSubmissions = async () => {
//     try {
//       const querySnapshot = await getDocs(collection(db, "formSubmissions"));
//       const data = querySnapshot.docs.map((doc) => ({
//         id: doc.id,
//         ...doc.data(),
//       }));
//       setSubmissions(data);
//     } catch (error) {
//       console.error("Error fetching submissions:", error);
//     }
//   };

//   fetchSubmissions();
// }, []);





const [submissions, setSubmissions] = useState([]);
const [filters, setFilters] = useState({
  feeType: '',
  month: ''
});

useEffect(() => {
  const fetchSubmissions = async () => {
    try {
      const querySnapshot = await getDocs(collection(db, "formSubmissions"));
      const data = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      // Sort by submit date (newest first)
      const sortedData = data.sort((a, b) => {
        // Get submit dates for comparison
        const getSubmitDate = (sub) => {
          if (sub.submittedAt?.seconds) {
            return new Date(sub.submittedAt.seconds * 1000);
          }
          if (sub.submittedAt) {
            return new Date(sub.submittedAt);
          }
          if (sub.date) {
            return new Date(sub.date);
          }
          return new Date(0); // Fallback for submissions without date
        };

        const dateA = getSubmitDate(a);
        const dateB = getSubmitDate(b);
        
        return dateB - dateA; // Descending order (newest first)
      });

      setSubmissions(sortedData);
    } catch (error) {
      console.error("Error fetching submissions:", error);
    }
  };

  fetchSubmissions();
}, []);

const filteredSubmissions = submissions.filter(submission => {
  // Filter by fee type
  if (filters.feeType && submission.feeType !== filters.feeType) {
    return false;
  }
  
  // Filter by month
  if (filters.month) {
    const submissionDate = submission.submittedAt?.seconds 
      ? new Date(submission.submittedAt.seconds * 1000)
      : new Date(submission.date || submission.submittedAt);
    
    const submissionMonth = submissionDate.getMonth() + 1; // JavaScript months are 0-11
    const filterMonth = parseInt(filters.month);
    
    if (submissionMonth !== filterMonth) {
      return false;
    }
  }
  
  return true;
});

// Get unique fee types for dropdown
const uniqueFeeTypes = [...new Set(submissions.map(sub => sub.feeType))].filter(Boolean);







// Add this function to update status in Firestore
const updateSubmissionStatus = async (submissionId, newStatus) => {
  try {
    await updateDoc(doc(db, "formSubmissions", submissionId), {
      status: newStatus,
      updatedAt: new Date()
    });
    // Update local state to reflect changes immediately
    setSubmissions(submissions.map(sub => 
      sub.id === submissionId ? {...sub, status: newStatus} : sub
    ));
  } catch (error) {
    console.error("Error updating status:", error);
    alert("Failed to update status");
  }
};






// // const [paymentNumber, setPaymentNumber] = useState(Math.floor(1000 + Math.random() * 9000));
// const [paymentNumber, setPaymentNumber] = useState('0001');

// const handleCreatePaymentSlip = async () => {
//   if (!paymentDate || !studentName || !studentEmail || !paymentfor || !amount) {
//     window.alert("Please fill in all required fields before proceeding!");
//     return;
//   }

//   const paymentData = {
//     paymentDate: String(paymentDate).trim(),
//     studentName: String(studentName).trim(),
//     studentEmail: String(studentEmail).trim(),
//     paymentType: paymentType,
//     paymentfor: paymentfor,
//     amount: parseFloat(amount) || 0,
//     paymentNumber: paymentNumber,
//     createdAt: new Date(),
//   };

//   console.log("Payment Data:", paymentData);

//   try {
//     // Save to Firestore
//     await addDoc(collection(db, "payments"), paymentData);

//     // Create PDF
//     const doc = new jsPDF({
//       orientation: "landscape",
//       unit: "mm",
//       format: [210, 148], // Half A4 (similar to A5 portrait)
//     });

//     // --- Header ---
//     doc.setFillColor(21, 27, 84);
//     doc.rect(0, 0, doc.internal.pageSize.getWidth(), 25, "F");
//     doc.setFontSize(16);
//     doc.setTextColor(255, 255, 255);
//     doc.text("Eye Care Institute", doc.internal.pageSize.getWidth() / 2, 12, { align: "center" });
//     doc.setFontSize(10);
//     doc.text("College of Optometry and Vision Science", doc.internal.pageSize.getWidth() / 2, 18, { align: "center" });

//     // --- Payment Slip Title ---
//     doc.setFont("helvetica", "bold");
//     doc.setFontSize(14);
//     doc.setTextColor(0, 0, 0);
//     doc.text("PAYMENT SLIP", doc.internal.pageSize.getWidth() / 2, 35, { align: "center" });

//     // --- Payment Details ---
//     doc.setFontSize(10);
//     doc.text(`Payment No: ${paymentNumber}`, 10, 45);
//     doc.text(`Date: ${paymentData.paymentDate}`, doc.internal.pageSize.getWidth() - 10, 45, { align: "right" });

//     doc.text("Student Name:", 10, 55);
//     doc.text(paymentData.studentName, 40, 55);

//     doc.text("Student Email:", 10, 62);
//     doc.text(paymentData.studentEmail, 40, 62);

//     doc.text("Payment for:", 10, 69);
//     doc.text(
//       paymentData.paymentfor === 'exam' ? 'Exam Fee' : 
//       paymentData.paymentfor === 'admission' ? 'Admission Fee' : 'Class Fee', 
//       40, 69
//     );

//     doc.text("Payment Type:", 10, 76);
//     doc.text(paymentData.paymentType === 'deposit' ? 'Deposit' : 'Bank Transfer', 40, 76);

//     // --- Amount ---
//     doc.setFont("helvetica", "bold");
//     doc.text("Amount Paid:", 10, 89);
//     doc.text(`Rs. ${paymentData.amount.toFixed(2)}`, doc.internal.pageSize.getWidth() - 10, 89, { align: "right" });
//     doc.line(10, 93, doc.internal.pageSize.getWidth() - 10, 93);

//     // --- Footer ---
//     doc.setFontSize(8);
//     doc.setTextColor(100, 100, 100);
//     doc.text("932, Maradana Road, Colombo 08", doc.internal.pageSize.getWidth() / 2, 130, { align: "center" });
//     doc.text("Email: ecinstitute@gmail.com | Phone: 011-268-22-77", doc.internal.pageSize.getWidth() / 2, 135, { align: "center" });
//     doc.text("Website: www.eyecareinstitute.lk", doc.internal.pageSize.getWidth() / 2, 140, { align: "center" });

//     // Save the PDF
//     doc.save(`Payment-${paymentNumber}.pdf`);

//     // Reset form
//     setPaymentDate('');
//     setStudentName('');
//     setStudentEmail('');
//     setPaymentfor('exam');
//     setPaymentType('deposit');
//     setAmount('');
//     setPaymentNumber(Math.floor(1000 + Math.random() * 9000));
//   } catch (error) {
//     console.error("Error creating payment slip: ", error);
//     window.alert("Error generating payment slip. Please try again.");
//   }
// };




// State initialization
const [paymentDate, setPaymentDate] = useState('');
const [studentName, setStudentName] = useState('');
const [studentEmail, setStudentEmail] = useState('');
const [paymentfor, setPaymentfor] = useState('registration');
const [paymentType, setPaymentType] = useState('deposit');
const [amount, setAmount] = useState('');

const [paymentNumber, setPaymentNumber] = useState('0001');

useEffect(() => {
  const initializePaymentNumber = async () => {
    try {
      const paymentsRef = collection(db, "payments");
      const q = query(paymentsRef, orderBy("paymentNumber", "desc"), limit(1));
      const querySnapshot = await getDocs(q);

      if (querySnapshot.empty) {
        // No payments exist yet, start with 0001
        setPaymentNumber('0001');
      } else {
        // Get the last payment number and increment
        const lastPayment = querySnapshot.docs[0].data();
        const lastNumber = lastPayment.paymentNumber;
        
        // Handle both string and number formats
        const num = typeof lastNumber === 'number' ? lastNumber : parseInt(lastNumber, 10);
        const nextNumber = (num + 1).toString().padStart(4, '0');
        setPaymentNumber(nextNumber);
      }
    } catch (error) {
      console.error("Error initializing payment number:", error);
      // Fallback to 0001 if there's an error
      setPaymentNumber('0001');
    }
  };

  initializePaymentNumber();
}, []);




const handleCreatePaymentSlip = async () => {
  if (!paymentDate || !studentName || !studentEmail || !paymentfor || !amount) {
    window.alert("Please fill in all required fields before proceeding!");
    return;
  }

  const paymentData = {
    paymentDate: String(paymentDate).trim(),
    studentName: String(studentName).trim(),
    studentEmail: String(studentEmail).trim(),
    paymentType: paymentType,
    paymentfor: paymentfor,
    amount: parseFloat(amount) || 0,
    paymentNumber: paymentNumber, // Use current payment number
    createdAt: new Date(),
  };

  try {
    // Save to Firestore
    await addDoc(collection(db, "payments"), paymentData);


    // Create PDF (keep your existing PDF generation code)
    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: [210, 148],
    });
  const logo = "/round.png"; 
  
    // --- Header ---
    doc.setFillColor(21, 27, 84);
    doc.rect(0, 0, doc.internal.pageSize.getWidth(), 25, "F");
    doc.addImage(logo, "PNG", 10, 2, 20, 20);
    doc.setFontSize(16);
    doc.setTextColor(255, 255, 255);
    doc.text("Ceylon Eye Care Optometry Association", doc.internal.pageSize.getWidth() / 2, 12, { align: "center" });
    doc.setFontSize(10);
    doc.text("", doc.internal.pageSize.getWidth() / 2, 18, { align: "center" });

    // --- Payment Slip Title ---
    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);
    doc.setTextColor(0, 0, 0);
    doc.text("PAYMENT SLIP", doc.internal.pageSize.getWidth() / 2, 35, { align: "center" });

    // --- Payment Details ---
    doc.setFontSize(10);
    doc.text(`Payment No: ${paymentNumber}`, 10, 45);
    doc.text(`Date: ${paymentData.paymentDate}`, doc.internal.pageSize.getWidth() - 10, 45, { align: "right" });

    doc.text("Name:", 10, 55);
    doc.text(paymentData.studentName, 40, 55);

    doc.text(" Email:", 10, 62);
    doc.text(paymentData.studentEmail, 40, 62);

    doc.text("Payment For:", 10, 69);
    doc.text(
      paymentData.paymentfor === 'registration' ? 'Registration Fee' : 
      paymentData.paymentfor === 'membership' ? 'Membership Fee' :
      paymentData.paymentfor === 'sponsorship' ? 'Sponsorship Fee' :
      paymentData.paymentfor === 'event' ? 'Event Fee' : 'Other',
      40, 69
    );

    doc.text("Payment Type:", 10, 76);
    doc.text(paymentData.paymentType === 'deposit' ? 'Deposit' : 'Bank Transfer', 40, 76);

    // --- Amount ---
    doc.setFont("helvetica", "bold");
    doc.text("Amount Paid:", 10, 89);
    doc.text(`Rs. ${paymentData.amount.toFixed(2)}`, doc.internal.pageSize.getWidth() - 10, 89, { align: "right" });
    doc.line(10, 93, doc.internal.pageSize.getWidth() - 10, 93);


  
    // --- Footer ---
    doc.setFontSize(8);
    doc.setTextColor(100, 100, 100);
    doc.text("932, Maradana Road, Colombo 08", doc.internal.pageSize.getWidth() / 2, 130, { align: "center" });
    doc.text("Email: info@optometryassociation.lk | Phone: 011-268-22-77", doc.internal.pageSize.getWidth() / 2, 135, { align: "center" });
    doc.text("Website: www.optometryassociation.lk", doc.internal.pageSize.getWidth() / 2, 140, { align: "center" });

    // Save the PDF with current payment number
    // Save the PDF
    doc.save(`Payment-${paymentNumber}.pdf`);

    // Calculate next payment number (current + 1)
    const nextNumber = (parseInt(paymentNumber, 10) + 1).toString().padStart(4, '0');
    setPaymentNumber(nextNumber);

    // Reset form fields (except payment number)
    setPaymentDate('');
    setStudentName('');
    setStudentEmail('');
    setPaymentfor('registration');
    setPaymentType('deposit');
    setAmount('');

  } catch (error) {
    console.error("Error creating payment slip: ", error);
    window.alert("Error generating payment slip. Please try again.");
  }
};







// //fetch all the payments from the payments collection
// const ViewPaymentHistory = () => {
//   const [payments, setPayments] = useState([]);
//   const [filteredPayments, setFilteredPayments] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [searchTerm, setSearchTerm] = useState('');

//   useEffect(() => {
//     const fetchPayments = async () => {
//       try {
//         const paymentsRef = collection(db, 'payments');
//         const q = query(paymentsRef, orderBy('paymentDate', 'desc'));
        
//         const unsubscribe = onSnapshot(q, (querySnapshot) => {
//           const paymentsData = [];
//           querySnapshot.forEach((doc) => {
//             paymentsData.push({
//               id: doc.id,
//               ...doc.data()
//             });
//           });
//           setPayments(paymentsData);
//           setFilteredPayments(paymentsData);
//           setLoading(false);
//         });

//         return () => unsubscribe();
//       } catch (err) {
//         setError(err.message);
//         setLoading(false);
//         console.error("Error fetching payments: ", err);
//       }
//     };

//     fetchPayments();
//   }, []);

//   useEffect(() => {
//     if (searchTerm.trim() === '') {
//       setFilteredPayments(payments);
//     } else {
//       const filtered = payments.filter(payment => 
//         payment.studentName.toLowerCase().includes(searchTerm.toLowerCase()) ||
//         payment.studentEmail.toLowerCase().includes(searchTerm.toLowerCase())
//       );
//       setFilteredPayments(filtered);
//     }
//   }, [searchTerm, payments]);

//   const formatDate = (dateString) => {
//     if (!dateString) return 'N/A';
//     const date = new Date(dateString);
//     return date.toLocaleDateString('en-US', {
//       year: 'numeric',
//       month: 'short',
//       day: 'numeric'
//     });
//   };

// const formatPaymentFor = (type) => {
//   switch(type) {
//     case 'exam': return 'Exam Fee';
//     case 'admission': return 'Admission Fee';
//     case 'registration': return 'Registration Fee';
//     case 'class': return 'Class Fee';
//     default: return type;
//   }
// };

//   const exportToExcel = () => {
//     const worksheet = XLSX.utils.json_to_sheet(filteredPayments.map(payment => ({
//       'Payment Number': payment.paymentNumber,
//       'Date': formatDate(payment.paymentDate),
//       'Student Name': payment.studentName,
//       'Student Email': payment.studentEmail,
//       'Payment Type': payment.paymentType === 'deposit' ? 'Deposit' : 'Bank Transfer',
//       'Payment For': formatPaymentFor(payment.paymentfor),
//       'Amount (LKR)': payment.amount.toFixed(2)
//     })));
    
//     const workbook = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(workbook, worksheet, "Payment History");
//     XLSX.writeFile(workbook, "Payment_History.xlsx");
//   };

//   if (loading) return <div className="loading">Loading payment history...</div>;
//   if (error) return <div className="error">Error: {error}</div>;

//   return (
//     <div className="view-payment-history">
//       <div className="payment-history-header">
//         <h3>View Payment History</h3>
//         <div className="payment-history-actions">
//           <div className="search-box">
//             <input
//               type="text"
//               placeholder="Search by name or email..."
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//             />
//             <span className="search-icon">🔍</span>
//           </div>
//           <button onClick={exportToExcel} className="export-excel-btn">
//             Export to Excel
//           </button>
//         </div>
//       </div>
      
//       {filteredPayments.length === 0 ? (
//         <div className="no-payments">
//           {payments.length === 0 ? 'No payment records found.' : 'No matching payments found.'}
//         </div>
//       ) : (
//         <div className="payments-table-container">
//           <table className="payments-table">
//             <thead>
//               <tr>
//                 <th>Payment #</th>
//                 <th>Date</th>
//                 <th>Student Name</th>
//                 <th>Student Email</th>
//                 <th>Payment Type</th>
//                 <th>Payment For</th>
//                 <th>Amount (LKR)</th>
//                 <th>Payment Slip</th>
//               </tr>
//             </thead>
//             <tbody>
//               {filteredPayments.map((payment) => (
//                 <tr key={payment.id}>
//                   <td>{payment.paymentNumber}</td>
//                   <td>{formatDate(payment.paymentDate)}</td>
//                   <td>{payment.studentName}</td>
//                   <td>{payment.studentEmail}</td>
//                   <td>{payment.paymentType === 'deposit' ? 'Deposit' : 'Bank Transfer'}</td>
//                   <td>{formatPaymentFor(payment.paymentfor)}</td>
//                   <td className="amount">{payment.amount.toFixed(2)}</td>
//                   <td>
              
//                   <button onClick={() => downloadPaymentSlip(payment)}>Download</button>
             
//                 </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       )}
//     </div>
//   );
// };



//fetch all the payments from the payments collection
// const ViewPaymentHistory = () => {
//   const [payments, setPayments] = useState([]);
//   const [filteredPayments, setFilteredPayments] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [deletingId, setDeletingId] = useState(null); // Track which payment is being deleted

//   useEffect(() => {
//     const fetchPayments = async () => {
//       try {
//         const paymentsRef = collection(db, 'payments');
//         const q = query(paymentsRef, orderBy('paymentDate', 'desc'));
        
//         const unsubscribe = onSnapshot(q, (querySnapshot) => {
//           const paymentsData = [];
//           querySnapshot.forEach((doc) => {
//             paymentsData.push({
//               id: doc.id,
//               ...doc.data()
//             });
//           });
//           setPayments(paymentsData);
//           setFilteredPayments(paymentsData);
//           setLoading(false);
//         });

//         return () => unsubscribe();
//       } catch (err) {
//         setError(err.message);
//         setLoading(false);
//         console.error("Error fetching payments: ", err);
//       }
//     };

//     fetchPayments();
//   }, []);

//   useEffect(() => {
//     if (searchTerm.trim() === '') {
//       setFilteredPayments(payments);
//     } else {
//       const filtered = payments.filter(payment => 
//         payment.studentName.toLowerCase().includes(searchTerm.toLowerCase()) ||
//         payment.studentEmail.toLowerCase().includes(searchTerm.toLowerCase()) ||
//          payment.paymentfor.toLowerCase().includes(searchTerm.toLowerCase())
//       );
//       setFilteredPayments(filtered);
//     }
//   }, [searchTerm, payments]);

//   const formatDate = (dateString) => {
//     if (!dateString) return 'N/A';
//     const date = new Date(dateString);
//     return date.toLocaleDateString('en-US', {
//       year: 'numeric',
//       month: 'short',
//       day: 'numeric'
//     });
//   };

//   const formatPaymentFor = (type) => {
//     switch(type) {
//       case 'exam': return 'Exam Fee';
//       case 'admission': return 'Admission Fee';
//       case 'registration': return 'Registration Fee';
//       case 'class': return 'Class Fee';
//       default: return type;
//     }
//   };

//   const exportToExcel = () => {
//     const worksheet = XLSX.utils.json_to_sheet(filteredPayments.map(payment => ({
//       'Payment Number': payment.paymentNumber,
//       'Date': formatDate(payment.paymentDate),
//       'Student Name': payment.studentName,
//       'Student Email': payment.studentEmail,
//       'Payment Type': payment.paymentType === 'deposit' ? 'Deposit' : 'Bank Transfer',
//       'Payment For': formatPaymentFor(payment.paymentfor),
//       'Amount (LKR)': payment.amount.toFixed(2)
//     })));
    
//     const workbook = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(workbook, worksheet, "Payment History");
//     XLSX.writeFile(workbook, "Payment_History.xlsx");
//   };

//   const handleDeletePayment = async (paymentId) => {
//     if (!window.confirm('Are you sure you want to delete this payment record? This action cannot be undone.')) {
//       return;
//     }
    
//     try {
//       setDeletingId(paymentId);
//       await deleteDoc(doc(db, 'payments', paymentId));
//       // No need to update state manually as onSnapshot will handle it
//     } catch (err) {
//       console.error("Error deleting payment: ", err);
//       alert('Failed to delete payment. Please try again.');
//     } finally {
//       setDeletingId(null);
//     }
//   };

//   if (loading) return <div className="loading">Loading payment history...</div>;
//   if (error) return <div className="error">Error: {error}</div>;

//   return (
//     <div className="view-payment-history">
//       <div className="payment-history-header">
//         <h3>View Payment History</h3>
//         <div className="payment-history-actions">
//           <div className="search-box">
//             <input
//               type="text"
//               placeholder="Search by name or payment type..."
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//             />
//             <span className="search-icon">🔍</span>
//           </div>
//           <button onClick={exportToExcel} className="export-excel-btn">
//             Export to Excel
//           </button>
//         </div>
//       </div>
      
//       {filteredPayments.length === 0 ? (
//         <div className="no-payments">
//           {payments.length === 0 ? 'No payment records found.' : 'No matching payments found.'}
//         </div>
//       ) : (
//         <div className="payments-table-container">
          // <table className="payments-table">
          //   <thead>
          //     <tr>
          //       <th>Payment #</th>
          //       <th>Date</th>
          //       <th>Student Name</th>
          //       <th>Student Email</th>
          //       <th>Payment Type</th>
          //       <th>Payment For</th>
          //       <th>Amount (LKR)</th>
          //       <th>Payment Slip</th>
          //       <th>Actions</th>
          //     </tr>
          //   </thead>
          //   <tbody>
          //     {filteredPayments.map((payment) => (
          //       <tr key={payment.id}>
          //         <td>{payment.paymentNumber}</td>
          //         <td>{formatDate(payment.paymentDate)}</td>
          //         <td>{payment.studentName}</td>
          //         <td>{payment.studentEmail}</td>
          //         <td>{payment.paymentType === 'deposit' ? 'Deposit' : 'Bank Transfer'}</td>
          //         <td>{formatPaymentFor(payment.paymentfor)}</td>
          //         <td className="amount">{payment.amount.toFixed(2)}</td>
          //         <td>
          //           <button onClick={() => downloadPaymentSlip(payment)}>Download</button>
          //         </td>
          //         <td>
          //           <button 
          //             onClick={() => handleDeletePayment(payment.id)}
          //             disabled={deletingId === payment.id}
          //             className="delete-btn"
          //           >
          //             {deletingId === payment.id ? 'Deleting...' : 'Delete'}
          //           </button>
          //         </td>
          //       </tr>
          //     ))}
          //   </tbody>
          // </table>
//         </div>
//       )}
//     </div>
//   );
// };











const ViewPaymentHistory = () => {
  // All hooks must be at the top level
  const [payments, setPayments] = useState([]);
  const [filteredPayments, setFilteredPayments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [deletingId, setDeletingId] = useState(null);
  const [filters, setFilters] = useState({
    year: '',
    month: '',
    paymentFor: ''
  });

  // Payment for options
  const paymentForOptions = [
    { value: '', label: 'All Types' },
    { value: 'registration', label: 'Registration Fee' },
    { value: 'membership', label: 'Membership' },
    { value: 'sponsorship', label: 'Sponsorship Fee' },
    { value: 'event', label: 'Event Fee' },
    { value: 'other', label: 'Other' }
  ];

  // Get unique years from payments
  const getUniqueYears = () => {
    const years = new Set();
    payments.forEach(payment => {
      if (payment.paymentDate) {
        years.add(new Date(payment.paymentDate).getFullYear());
      }
    });
    return Array.from(years).sort((a, b) => b - a);
  };

  useEffect(() => {
    const fetchPayments = async () => {
      try {
        const paymentsRef = collection(db, 'payments');
        const q = query(paymentsRef, orderBy('paymentDate', 'desc'));
        
        const unsubscribe = onSnapshot(q, (querySnapshot) => {
          const paymentsData = [];
          querySnapshot.forEach((doc) => {
            paymentsData.push({
              id: doc.id,
              ...doc.data()
            });
          });
          setPayments(paymentsData);
          setLoading(false);
        });

        return () => unsubscribe();
      } catch (err) {
        setError(err.message);
        setLoading(false);
        console.error("Error fetching payments: ", err);
      }
    };

    fetchPayments();
  }, []);

  useEffect(() => {
    let filtered = [...payments];
    
    // Apply search term filter
    if (searchTerm.trim() !== '') {
      filtered = filtered.filter(payment => 
        payment.studentName.toLowerCase().includes(searchTerm.toLowerCase()) ||
        payment.studentEmail.toLowerCase().includes(searchTerm.toLowerCase()) ||
        payment.paymentfor.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }
    
    // Apply year filter
    if (filters.year) {
      filtered = filtered.filter(payment => {
        if (!payment.paymentDate) return false;
        return new Date(payment.paymentDate).getFullYear() === parseInt(filters.year);
      });
    }
    
    // Apply month filter
    if (filters.month) {
      filtered = filtered.filter(payment => {
        if (!payment.paymentDate) return false;
        return new Date(payment.paymentDate).getMonth() + 1 === parseInt(filters.month);
      });
    }
    
    // Apply paymentFor filter
    if (filters.paymentFor) {
      filtered = filtered.filter(payment => 
        payment.paymentfor === filters.paymentFor
      );
    }
    
    setFilteredPayments(filtered);
  }, [searchTerm, payments, filters]);

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  const formatPaymentFor = (type) => {
    switch(type) {
      case 'registration': return 'Registration Fee';
      case 'membership': return 'Membership';
      case 'sponsorship': return 'Sponsorship';
      case 'event': return 'Event Fee';
      case 'other': return 'Other';
      default: return type;
    }
  };

  const exportToExcel = () => {
    if (filteredPayments.length === 0) {
      alert('No data to export!');
      return;
    }
    
    const worksheet = XLSX.utils.json_to_sheet(filteredPayments.map(payment => ({
      'Payment Number': payment.paymentNumber,
      'Date': formatDate(payment.paymentDate),
      'Name': payment.studentName,
      'Email': payment.studentEmail,
      'Payment Type': payment.paymentType === 'deposit' ? 'Deposit' : 'Bank Transfer',
      'Payment For': formatPaymentFor(payment.paymentfor),
      'Amount (LKR)': payment.amount.toFixed(2)
    })));
    
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Payment History");
    
    // Generate filename based on filters
    let filename = "Payment_History";
    if (filters.year) filename += `_${filters.year}`;
    if (filters.month) filename += `_${filters.month}`;
    if (filters.paymentFor) filename += `_${filters.paymentFor}`;
    
    XLSX.writeFile(workbook, `${filename}.xlsx`);
  };

  const handleDeletePayment = async (paymentId) => {
    if (!window.confirm('Are you sure you want to delete this payment record? This action cannot be undone.')) {
      return;
    }
    
    try {
      setDeletingId(paymentId);
      await deleteDoc(doc(db, 'payments', paymentId));
    } catch (err) {
      console.error("Error deleting payment: ", err);
      alert('Failed to delete payment. Please try again.');
    } finally {
      setDeletingId(null);
    }
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const resetFilters = () => {
    setFilters({
      year: '',
      month: '',
      paymentFor: ''
    });
    setSearchTerm('');
  };

  const downloadPaymentSlip = (payment) => {
    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: [210, 148], // Half A4 (similar to A5 portrait)
    });


    
    const logo = "/round.png"; // Path to your logo image
    // --- Header ---
    doc.setFillColor(21, 27, 84);
    doc.rect(0, 0, doc.internal.pageSize.getWidth(), 25, "F");
    doc.addImage(logo, "PNG", 10, 2, 20, 20);
    doc.setFontSize(16);
    doc.setTextColor(255, 255, 255);
    doc.text("Ceylon Eye CARE Optometry Association", doc.internal.pageSize.getWidth() / 2, 12, { align: "center" });
    doc.setFontSize(10);
    // doc.text("College of Optometry and Vision Science", doc.internal.pageSize.getWidth() / 2, 18, { align: "center" });

    // --- Payment Slip Title ---
    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);
    doc.setTextColor(0, 0, 0);
    doc.text("PAYMENT SLIP", doc.internal.pageSize.getWidth() / 2, 35, { align: "center" });

    // --- Payment Details ---
    doc.setFontSize(10);
    doc.text(`Payment No: ${payment.paymentNumber}`, 10, 45);
    doc.text(`Date: ${formatDate(payment.paymentDate)}`, doc.internal.pageSize.getWidth() - 10, 45, { align: "right" });

    doc.text("Name:", 10, 55);
    doc.text(payment.studentName, 40, 55);

    doc.text("Email:", 10, 62);
    doc.text(payment.studentEmail, 40, 62);

    doc.text("Payment For:", 10, 69);
    doc.text(
      payment.paymentfor === 'registration' ? 'Registration Fee' : 
      payment.paymentfor === 'membership' ? 'Membership Fee' :
      payment.paymentfor === 'sponsorship' ? 'Sponsorship Fee' :
      payment.paymentfor === 'event' ? 'Event Fee' : 'Other',
      40, 69
    );

    doc.text("Payment Type:", 10, 76);
    doc.text(payment.paymentType === 'deposit' ? 'Deposit' : 'Bank Transfer', 40, 76);

    // --- Amount ---
    doc.setFont("helvetica", "bold");
    doc.text("Amount Paid:", 10, 89);
    doc.text(`Rs. ${payment.amount.toFixed(2)}`, doc.internal.pageSize.getWidth() - 10, 89, { align: "right" });
    doc.line(10, 93, doc.internal.pageSize.getWidth() - 10, 93);

    // --- Footer ---
    doc.setFontSize(8);
    doc.setTextColor(100, 100, 100);
    doc.text("932, Maradana Road, Colombo 08", doc.internal.pageSize.getWidth() / 2, 130, { align: "center" });
    doc.text("Email: info@optometryassociation.lk | Phone: 011-268-22-77", doc.internal.pageSize.getWidth() / 2, 135, { align: "center" });
    doc.text("Website: www.optometryassociation.lk", doc.internal.pageSize.getWidth() / 2, 140, { align: "center" });

    // Save the PDF
    doc.save(`Payment-${payment.paymentNumber}.pdf`);
  };

  if (loading) return <div className="loading">Loading payment history...</div>;
  if (error) return <div className="error">Error: {error}</div>;

  return (
    <div className="view-payment-history">
      <div className="payment-history-header">
        <h3>View Payment History</h3>
        <div className="payment-history-filters">
          <div className="filter-group">
            <label>Year:</label>
            <select 
              name="year" 
              value={filters.year} 
              onChange={handleFilterChange}
            >
              <option value="">All Years</option>
              {getUniqueYears().map(year => (
                <option key={year} value={year}>{year}</option>
              ))}
            </select>
          </div>
          
          <div className="filter-group">
            <label>Month:</label>
            <select 
              name="month" 
              value={filters.month} 
              onChange={handleFilterChange}
            >
              <option value="">All Months</option>
              {Array.from({length: 12}, (_, i) => i + 1).map(month => (
                <option key={month} value={month}>
                  {new Date(0, month - 1).toLocaleString('default', {month: 'long'})}
                </option>
              ))}
            </select>
          </div>
          
          <div className="filter-group">
            <label>Payment For:</label>
            <select 
              name="paymentFor" 
              value={filters.paymentFor} 
              onChange={handleFilterChange}
            >
              {paymentForOptions.map(option => (
                <option key={option.value} value={option.value}>{option.label}</option>
              ))}
            </select>
          </div>
          




          <button onClick={resetFilters} className="reset-filters">
            Reset Filters
          </button>

                      <button 
    onClick={exportToExcel} 
    className="export-excel-btn"
    disabled={filteredPayments.length === 0}
  >
    Export to Excel
  </button>

  
        </div>

        <div className="search-export-section">
  <div className="search-box">
    <input
      type="text"
      placeholder="Search by name or email..."
      value={searchTerm}
      onChange={(e) => setSearchTerm(e.target.value)}
    />
    <span className="search-icon">🔍</span>
  </div>


</div>

      </div>
      
      {filteredPayments.length === 0 ? (
        <div className="no-payments">
          {payments.length === 0 ? 'No payment records found.' : 'No matching payments found.'}
        </div>
      ) : (
        <div className="payments-table-container">
          <div className="filter-summary">
            Showing {filteredPayments.length} of {payments.length} payments
            {filters.year && ` in ${filters.year}`}
            {filters.month && `, ${new Date(0, filters.month - 1).toLocaleString('default', {month: 'long'})}`}
            {filters.paymentFor && `, ${paymentForOptions.find(o => o.value === filters.paymentFor)?.label}`}
          </div>

          <table className="payments-table">
            <thead>
              <tr>
                <th>Payment #</th>
                <th>Date</th>
                <th>Member Name</th>
                <th>Member Email</th>
                <th>Payment Type</th>
                <th>Payment For</th>
                <th>Amount (LKR)</th>
                <th>Payment Slip</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredPayments.map((payment) => (
                <tr key={payment.id}>
                  <td>{payment.paymentNumber}</td>
                  <td>{formatDate(payment.paymentDate)}</td>
                  <td>{payment.studentName}</td>
                  <td>{payment.studentEmail}</td>
                  <td>{payment.paymentType === 'deposit' ? 'Deposit' : 'Bank Transfer'}</td>
                  <td>{formatPaymentFor(payment.paymentfor)}</td>
                  <td className="amount">{payment.amount.toFixed(2)}</td>
                  <td>
                    <button onClick={() => downloadPaymentSlip(payment)}>Download</button>         
                  </td>
                  <td>    
                    <button 
                      onClick={() => handleDeletePayment(payment.id)}
                      disabled={deletingId === payment.id}
                      className="delete-btn"
                    >
                      {deletingId === payment.id ? 'Deleting...' : 'Delete'}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};






  return (
    <div className="admin-panel">
      <div className="top-bar">
        <ul className="tabs">
          <li className={`tab ${activeTab === 'viewAllSubmission' ? 'active' : ''}`} onClick={() => handleTabClick('viewAllSubmission')}>
            View all payment submissions
          </li>

          <li className={`tab ${activeTab === 'createPaymentSlip' ? 'active' : ''}`} onClick={() => handleTabClick('createPaymentSlip')}>
            Create payment slips
          </li>

          <li className={`tab ${activeTab === 'viewPaymentHistory' ? 'active' : ''}`} onClick={() => handleTabClick('viewPaymentHistory')}>
            View Payment History
          </li>



          <li className={`tab ${activeTab === 'manageUsers' ? 'active' : ''}`} onClick={() => handleTabClick('manageUsers')}>
            Manage Members
          </li>
          <li className={`tab ${activeTab === 'contactMessage' ? 'active' : ''}`} onClick={() => handleTabClick('contactMessage')}>
            Contact Us Messages
          </li>
        </ul>
        <button className="logout-btn" onClick={handleLogout}>
          Logout
        </button>
      </div>

      <div className="main-content">



{/******************************************************************************************************************************/}



{activeTab === "viewAllSubmission" && (
  <div className="tab-content active">
    <h3>View All Payment Submissions</h3>
    
    {/* Filter Controls (existing code remains the same) */}
    <div className="row mb-4">
      <div className="col-md-4">
        <label>Fee Type:</label>
        <select 
          className="form-control"
          value={filters.feeType}
          onChange={(e) => setFilters({...filters, feeType: e.target.value})}
        >
          <option value="">All Fee Types</option>
          {uniqueFeeTypes.map(type => (
            <option key={type} value={type}>{type}</option>
          ))}
        </select>
      </div>
      <div className="col-md-4">
        <label>Month:</label>
        <select 
          className="form-control"
          value={filters.month}
          onChange={(e) => setFilters({...filters, month: e.target.value})}
        >
          <option value="">All Months</option>
          <option value="1">January</option>
          <option value="2">February</option>
          <option value="3">March</option>
          <option value="4">April</option>
          <option value="5">May</option>
          <option value="6">June</option>
          <option value="7">July</option>
          <option value="8">August</option>
          <option value="9">September</option>
          <option value="10">October</option>
          <option value="11">November</option>
          <option value="12">December</option>
        </select>
      </div>
      <div className="col-md-4 d-flex align-items-end">
        <button 
          className="btn btn-secondary"
          onClick={() => setFilters({feeType: '', month: ''})}
        >
          Clear Filters
        </button>
      </div>
    </div>
    
    {filteredSubmissions.length === 0 ? (
      <p>No submissions found matching your filters.</p>
    ) : (
      <div className="table-responsive">
        <table className="table table-striped table-bordered">
          <thead>


          <tr style={{ fontSize: '10px' }}>
            <th>Name</th>
            <th>NIC / Passport No</th>
            <th>Contact No</th>
            <th>Email</th>
            <th>Fee Type</th>
            <th>Payment Slip</th>
            <th>Status</th>
            <th>Actions</th>
            <th>Action 2</th>
            <th>Submitted At</th>
          </tr>


          </thead>
          <tbody>
            {filteredSubmissions.map((submission) => (
              <tr key={submission.id}>
                <td>{submission.name}</td>
                <td>{submission.nicPassportNo}</td>
                <td>{submission.contactNo}</td>
                <td>{submission.email}</td>
                <td>{submission.feeType}</td>
                <td>
                  {submission.paymentSlipUrl ? (
                    <a
                      href={submission.paymentSlipUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="file-link"
                    >
                      View Payment
                    </a>
                  ) : 'N/A'}
                </td>
                <td className={`status-cell ${(submission.status || '').toLowerCase()}`}>
                  {submission.status || 'Pending'}
                </td>
                <td className="actions-cell">
                  {(submission.status === undefined || 
                    submission.status === null || 
                    submission.status.toString().toLowerCase() === 'pending') && (
                    <>
                      <button 
                        onClick={() => updateSubmissionStatus(submission.id, 'Approved')}
                        className="btn btn-success btn-sm"
                      >
                        Approve
                      </button>
                      <button 
                        onClick={() => updateSubmissionStatus(submission.id, 'Rejected')}
                        className="btn btn-danger btn-sm ml-2"
                      >
                        Reject
                      </button> 
                    </>
                  )}
                  {submission.status && 
                  submission.status.toString().toLowerCase() !== 'pending' && (
                    <span className="status-badge">
                      {submission.status}
                    </span>
                  )}
                </td>
                <td>
                  <button 
                    onClick={() => {
                      if (window.confirm('Are you sure you want to delete this submission?')) {
                        deleteDoc(doc(db, "formSubmissions", submission.id))
                          .then(() => {
                            setSubmissions(submissions.filter(s => s.id !== submission.id));
                          })
                          .catch(error => {
                            console.error("Error deleting document: ", error);
                          });
                      }
                    }}
                    className="btn btn-danger btn-sm"
                  >
                    Delete
                  </button>
                </td>
                <td>
                  {submission.submittedAt?.seconds 
                    ? new Date(submission.submittedAt.seconds * 1000).toLocaleString() 
                    : new Date(submission.date || submission.submittedAt).toLocaleString()}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )}
  </div>
)}




{/*************************************************************************************************************************************/}


{activeTab === 'createPaymentSlip' && (
  <div className="create-paymentSlip-section">
  <h3 className="paymentSlip-heading">Generate Payment Slip</h3>
  
  <div className="payment-form">
    <div className="form-group">
      <label>Payment Date:</label>
      <input 
        type="date" 
        value={paymentDate}
        onChange={(e) => setPaymentDate(e.target.value)}
        required
      />
    </div>
    

<div className="form-group">
  <label>Payment Number:</label>
  <input 
    type="text" 
    value={paymentNumber}
    readOnly
    className="read-only-input"
  />
</div>

    <div className="form-group">
      <label>Member Name:</label>
      <input 
        type="text" 
        value={studentName}
        onChange={(e) => setStudentName(e.target.value)}
        required
      />
    </div>
    
    <div className="form-group">
      <label>Member Email:</label>
      <input 
        type="email" 
        value={studentEmail}
        onChange={(e) => setStudentEmail(e.target.value)}
        required
      />
    </div>

    <div className="form-group">
      <label>Payment For:</label>
      <select 
        value={paymentfor}
        onChange={(e) => setPaymentfor(e.target.value)}
      >
        <option value="registration">Registration Fee</option>
        <option value="membership">Membership</option>
        <option value="sponsorship">Sponsorship</option>
        <option value="event">Event Fee</option>
        <option value="other">Other</option>
      </select>
    </div>
    
    <div className="form-group">
      <label>Payment Type:</label>
      <select 
        value={paymentType}
        onChange={(e) => setPaymentType(e.target.value)}
      >
        <option value="deposit">Deposit</option>
        <option value="bank_transfer">Bank Transfer</option>
      </select>
    </div>
    
    <div className="form-group">
      <label>Amount (Rs.):</label>
      <input 
        type="number" 
        value={amount}
        onChange={(e) => setAmount(e.target.value)}
        min="0"
        step="0.01"
        required
      />
    </div>
    
    <button 
      className="generate-btn"
      onClick={handleCreatePaymentSlip}
    >
      Generate Payment Slip
    </button>
  </div>
</div>
)}




{/******************************************************************************************************************************/}

    {activeTab === 'viewPaymentHistory' && (
              <div className="tab-content active">
                <ViewPaymentHistory />
              </div>
            )}









{/******************************************************************************************************************************/}

        {activeTab === 'manageUsers' && (
          <div className="tab-content active">
            <h3>Manage Members</h3>
            <table className="users-table">
              <thead>
                <tr>
                <th>Name</th>
                  <th>Email</th>
                  <th>Contact No</th>
                  <th>Role</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {users.map(user => (
                  <tr key={user.id}>
                    <td>{user.name}</td>
                    <td>{user.email}</td>
                    <td>{user.contactNo}</td>
                    <td>{user.role}</td>
                    <td>
                      <button className="remove-btn" onClick={() => handleRemoveUser(user.id)}>
                        Remove
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

{/******************************************************************************************************************************/}


        {activeTab === "contactMessage" && (
            <div className="tab-content active">
            <h3>View Contact Messages</h3>
            {messages.length === 0 ? (
              <p>No messages found.</p>
            ) : (
              <table className="contact-table">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Phone</th>
                    <th>Message</th>
                  </tr>
                </thead>
                <tbody>
                  {messages.map((msg) => (
                    <tr key={msg.id}>
                      <td>{msg.name}</td>
                      <td>{msg.email}</td>
                      <td>{msg.phone}</td>
                      <td>{msg.message}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        )}

{/******************************************************************************************************************************/}


      </div>
    </div>
  );
}

export default AdminPanel;
